import {SettingsService} from '../pages/settings/settings.service';

import {NotificationService} from './notification.service';
import {Injectable} from '@angular/core';
import {ShareDataService} from './share-data.service';
import {locale} from 'devextreme/localization';

@Injectable({
	providedIn: 'root',
})
export class LocalizationService {
	public setCurrentLocalizationLanguage() {
		try {
			this._settingsService.getGeneralSettingsLocalization(
				{
					showLoadingIndicator: false,
				}
			).subscribe(
				(response) => {
					let resultValue = response.value;
					if (resultValue) {
						this._shareDataService.currentLocalizationLanguage = 'en';
						locale(resultValue);
					} else {
						this._shareDataService.currentLocalizationLanguage = 'en';
					}
				}
			);
		} catch {
			this._shareDataService.currentLocalizationLanguage = 'en';
		}

		this._shareDataService.currentLocalizationLanguage = 'en';
	}

	constructor(
		private _notificationService: NotificationService,
		private _settingsService: SettingsService,
		private _shareDataService: ShareDataService
	) {}
}
